import React from 'react';
export function ApplicationProcess() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-2129">
      <div className="max-w-4xl mx-auto px-4 md:px-8 pt-12" data-id="element-2130">
        <h2 className="text-2xl md:text-3xl font-bold uppercase mb-6" style={{
        fontFamily: 'Oswald, sans-serif',
        color: '#1e3d2f'
      }} data-id="element-2131">
          Application Process
        </h2>
        <div className="bg-white rounded-xl p-6 md:p-8 border shadow-sm" style={{
        borderColor: '#ede9e0'
      }} data-id="element-2132">
          <p className="text-base mb-4" style={{
          color: '#5a5a5a',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-2133">
            Membership applications are presented to the Board of Directors for
            approval once a month at the Club's Business Meeting held at 7:00pm
            in the Club House on the second Tuesday of each month.
          </p>
          <p className="text-base" style={{
          color: '#5a5a5a',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-2134">
            Approved applicants will be contacted by the membership manager{' '}
            <strong data-id="element-2135">by email</strong> with details covering the next "New Member
            Orientation".
          </p>
        </div>
      </div>
    </div>;
}